module.exports = __webpack_public_path__ + "static/media/40.1f46f560.jpg";